import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "add-condition" }

import { ConditionViewModel } from './models/conditionViewModel';
import { ConditionPickerOption } from './models/conditions';
import ConditionPicker from './ConditionPicker.vue';
import AddIcon from 'vue-material-design-icons/Plus.vue';
import { PropType, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddCondition',
  props: {
  availableConditions: {
    type: Array as PropType<ConditionPickerOption[]>,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: String,
  },
},
  emits: ["added"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isConditionPickerOpen = ref(false);

function openNewConditionPicker() {
  if (props.disabled) {
    return;
  }

  isConditionPickerOpen.value = true;
}

function closeNewConditionPicker() {
  isConditionPickerOpen.value = false;
}

function onConditionAdded(condition: ConditionViewModel) {
  closeNewConditionPicker();
  emit('added', condition);
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: openNewConditionPicker,
      class: _normalizeClass({ disabled: __props.disabled })
    }, [
      _createVNode(_component_n_tooltip, {
        position: "top",
        text: __props.tooltip
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createElementVNode("a", null, [
              _createVNode(AddIcon),
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "add-label" }, "Add filter", -1))
            ])
          ])
        ]),
        _: 3
      }, 8, ["text"])
    ], 2),
    (isConditionPickerOpen.value)
      ? _withDirectives((_openBlock(), _createBlock(ConditionPicker, {
          key: 0,
          "available-conditions": __props.availableConditions,
          onSelected: onConditionAdded,
          onCancel: closeNewConditionPicker
        }, null, 8, ["available-conditions"])), [
          [_directive_click_away, closeNewConditionPicker]
        ])
      : _createCommentVNode("", true)
  ]))
}
}

})